import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUnlock,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { uploadFileToIPFS, uploadJSONToIPFS } from "../../pinata";
import Marketplace from "../../REALTYSWAPMarketPlace.json";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

import styles from "./styles/Create.module.css";
import Card from "../../Components/Card/Card";
import cardBg from "../../Assets/card-img.jpg";
import axios from "axios";
import { toast } from "react-toastify";
import Loading from "../../Components/Loading/Loading";

function Create() {
  const [toggleSwitchBid, setToggleSwitchBid] = useState(false);
  const [openDrop, setOpenDrop] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(false);
  const [nftAddress, setNftAddress] = useState(false);
  const [dropdownContent, setDropdownContent] = useState("Single Family");
  const [formParams, updateFormParams] = useState({
    name: "",
    description: "",
    price: "",
    beds: "",
    bath: "",
    sqft: "",
    lotSqft: "",
    yearBuilt: "",
  });
  const [fileURL, setFileURL] = useState(null);
  const ethers = require("ethers");
  const [message, updateMessage] = useState("");
  const cardData = {
    name: "NFT#1",
    desc: "REALTY SWAP First NFT",
    website: "http://realtyswap.io",
    image: cardBg,
    price: "0.03ETH",
    currentlySelling: "True",
    address: "0xe81Bf5A757CB4f7F82a2F23b1e59bE45c33c5b13",
  };
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [placeAddress, setPlaceAddress] = useState("");
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null,
  });

  const { address } = useSelector((state) => state.wallet);
  const navigate = useNavigate();
  //This function uploads the NFT image to IPFS
  async function OnChangeFile(e) {
    var file = e.target.files[0];
    //check for file extension

    try {
      //upload the file to IPFS
      setIsFormLoading(true);
      const response = await uploadFileToIPFS(file);
      if (response.success === true) {
        // console.log("Uploaded image to Pinata: ", response.url);
        setFileURL(response.url);

        setUploadedImage(URL.createObjectURL(e.target.files[0]));
      }
    } catch (e) {
      console.log("Error during file upload", e);
    } finally {
      setIsFormLoading(false);
    }
  }

  //This function uploads the metadata to IPDS
  async function uploadMetadataToIPFS() {
    const { name, description, price } = formParams;
    //Make sure that none of the fields are empty
    if (!name || !description || !price || !fileURL) return;

    const nftJSON = {
      name,
      description,
      price,
      image: fileURL,
      propertyDtls: {
        attributes: {
          beds: formParams.beds,
          bath: formParams.bath,
          sqft: formParams.sqft,
          lotSqft: formParams.lotSqft,
          yearBuilt: formParams.yearBuilt,
          type: dropdownContent,
        },
        latitude: 90.99,
        longitude: 91.99,
        address: "14 Burgundy Drive",
        city: "Holmdel",
        state: "NJ",
        zipCode: "07733",
      },
    };

    try {
      //upload the metadata JSON to IPFS
      const response = await uploadJSONToIPFS(nftJSON);
      if (response.success === true) {
        // console.log("Uploaded JSON to Pinata: ", response);
        return response.pinataURL;
      }
    } catch (e) {
      console.log("error uploading JSON metadata:", e);
    }
  }

  async function listNFT(e) {
    e.preventDefault();
    setIsFormLoading(true);

    //Upload data to IPFS
    try {
      const metadataURL = await uploadMetadataToIPFS();
      //After adding your Hardhat network to your metamask, this code will get providers and signers
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      updateMessage("Please wait.. uploading (upto 5 mins)");

      //Pull the deployed contract instance
      let contract = new ethers.Contract(
        Marketplace.address,
        Marketplace.abi,
        signer
      );
      //massage the params to be sent to the create NFT request
      const price = ethers.utils.parseUnits(formParams.price, "ether");
      let listingPrice = await contract.getListPrice();
      listingPrice = listingPrice.toString();

      //actually create the NFT
      let transaction = await contract.createToken(metadataURL, price, {
        value: listingPrice,
      });
      //sending the nft to the server for it to be stored
      let tokenId = await transaction.wait();
      let trans = await contract.getLatestIdToListedToken();
      const denaryToken = parseInt(trans.tokenId._hex, 16);
      console.log(trans);
      const data = {
        address: nftAddress,
        bath: formParams.bath,
        beds: formParams.beds,
        blockExplorerLink: "test",
        city: "nj",
        contractId: contract.address,
        description: formParams.description,
        imageUrl: fileURL,
        latitude: coordinates.lat,
        longitude: coordinates.lng,
        lotSqft: formParams.lotSqft,
        name: formParams.name,
        propId: "0",
        shortDescription: "test",
        sqft: formParams.sqft,
        state: "nj",
        tokenId: denaryToken,
        type: dropdownContent,
        walletAddress: address,
        walletChain: "ether",
        yearBuilt: formParams.yearBuilt,
        zipCode: "09999",
      };

      axios
        .post("/asset", data)
        .then((res) => {
          // console.log(res.data);
          // window.location.replace("/");
          // navigate("/");
        })
        .catch((err) => {
          console.log(err);
          toast.error(
            "Uh Oh! Something went wrong while storing asset to our servers after creation"
          );
        });

      alert("Successfully listed your NFT!");
      updateMessage("");
      updateFormParams({
        name: "",
        description: "",
        price: "",
        beds: "",
        bath: "",
        lotSqft: "",
        sqft: "",
        yearBuilt: "",
      });
    } catch (e) {
      alert("Upload error" + e);
      toast.error("Upload error");
    } finally {
      setIsFormLoading(false);
    }
  }
  // when user selects an address from the drop down this api gets the data for the nft of that address ------------
  const handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const ll = await getLatLng(results[0]);
    setPlaceAddress(value);
    setCoordinates(ll);
    setNftAddress(results[0].formatted_address);

    setIsFormLoading(true);

    try {
      const res = await axios.post("https://www.realtyswap.io/propertyInfo", {
        addressLine: results[0].formatted_address,
        requestType: "BY_ADDRESS_LINE",
        latitude: coordinates.lat,
        longitude: coordinates.lng,
      });
      if (res.data.propertyList.length > 0) {
        setUploadedImage(res.data.propertyList[0].images[0]);

        updateFormParams((prevState) => {
          return {
            ...prevState,
            beds: res.data.propertyList[0].bedrooms,
            bath: res.data.propertyList[0].bathrooms,
            description: res.data.propertyList[0].description,
            yearBuilt: res.data.propertyList[0].yearBuilt,
            name: res.data.propertyList[0].streetAddress,
          };
        });
        setDropdownContent(res.data.propertyList[0].homeType);
      } else {
        setDropdownContent("Single Family");
        setUploadedImage("");
        updateFormParams({
          name: "",
          description: "",
          price: "",
          beds: "",
          bath: "",
          lotSqft: "",
          sqft: "",
          yearBuilt: "",
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsFormLoading(false);
    }
  };

  // useEffect(() => {
  //   const script = document.createElement("script");
  //   script.src =
  //     "https://maps.googleapis.com/maps/api/js?key=AIzaSyDUBgwqY5F3J072rkuKgvrPxhj9dD4m7O0&libraries=places";
  //   script.async = true;
  //   document.body.appendChild(script);
  //   return () => {
  //     document.body.removeChild(script);
  //   };
  // }, []);

  // console.log("Working", process.env);
  return (
    <div
      style={{ marginBottom: "150px", minHeight: "100vh" }}
      className="container"
    >
      {isFormLoading && <Loading />}
      <div className={styles.createHeader}>
        <h1>Create New Nft</h1>
      </div>
      <div className={styles.createBottom}>
        <div className={styles.leftBottom}>
          <form>
            <PlacesAutocomplete
              value={placeAddress}
              onChange={setPlaceAddress}
              onSelect={handleSelect}
            >
              {({
                getInputProps,
                suggestions,
                getSuggestionItemProps,
                loading,
              }) => (
                <div className={`${styles.inputCol} ${styles.relative}`}>
                  <div className={styles.inputCol}>
                    <h2>Home Address</h2>
                    <input
                      {...getInputProps({
                        placeholder: "Search Places ...",
                        className: "location-search-input",
                      })}
                      required
                    />
                  </div>

                  {suggestions.length > 0 && (
                    <div
                      style={{ zIndex: 6, height: "auto" }}
                      className={styles.stateDrop}
                    >
                      {loading && <div>Loading...</div>}
                      {suggestions.map((suggestion) => {
                        const className = suggestion.active
                          ? "suggestion-item--active"
                          : "suggestion-item";
                        // inline style for demonstration purpose
                        const style = suggestion.active
                          ? { backgroundColor: "#fafafa", cursor: "pointer" }
                          : { backgroundColor: "#ffffff", cursor: "pointer" };
                        return (
                          <div
                            // className={styles.searchedItem}
                            key={suggestion.id}
                            {...getSuggestionItemProps(suggestion, {
                              className: `${className} ${styles.searchedItem}`,
                              style,
                            })}
                          >
                            <span>{suggestion.description}</span>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </PlacesAutocomplete>

            {fileURL || uploadedImage ? (
              <div className="w-100 p-relative">
                <img
                  className={styles.uploadedImage}
                  src={uploadedImage}
                  alt="uploaded"
                />
                <button
                  className="cta-btn centered"
                  onClick={(e) => {
                    e.preventDefault();
                    setFileURL("");
                    setUploadedImage("");
                  }}
                >
                  DISCARD
                </button>
              </div>
            ) : (
              <div className={styles.inputCol}>
                <h2 htmlFor="upload">Upload File</h2>
                <input
                  onChange={OnChangeFile}
                  id="upload"
                  type="file"
                  className={styles.file}
                />
                <div className={styles.uploadDiv}>
                  <h4>PNG, JPG, GIF, WEBP or MP4. Max 200mb.</h4>
                  <label htmlFor="upload">
                    <h6 style={{ width: "fit-content" }} className="cta-btn">
                      Browse
                    </h6>
                  </label>
                </div>
              </div>
            )}
            <div className={styles.inputCol}>
              <div className={styles.toggleRow}>
                <div className={styles.leftToggle}>
                  <h2>
                    <FontAwesomeIcon icon={faUnlock} /> Open for offers
                  </h2>
                  <p>Unlock content after successful transaction.</p>
                </div>
                <label className="switch">
                  <input
                    value={toggleSwitchBid}
                    onChange={() => setToggleSwitchBid((prev) => !prev)}
                    type="checkbox"
                  />
                  <span className="slider"></span>
                </label>
              </div>
            </div>

            {/* when you select the box open for bids then this input appears -------------- */}
            {toggleSwitchBid && (
              <>
                <div className={styles.inputCol}>
                  <h2>Price</h2>
                  <input
                    type="text"
                    placeholder="enter price for one item (ETH)"
                  />
                </div>
                <div className={styles.inputCol}>
                  <h2>Minimum bid</h2>
                  <input type="text" placeholder="enter minimum bid" />
                </div>
              </>
            )}

            <div className={styles.inputCol}>
              <h2>Title</h2>
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, name: e.target.value })
                }
                value={formParams.name}
                type="text"
                placeholder="e.g. 'Crypto Funk'"
              />
            </div>
            <div className={styles.inputCol}>
              <h2>Description</h2>
              <textarea
                type="text"
                placeholder="e.g. 'This is a very limited item'"
                onChange={(e) =>
                  updateFormParams({
                    ...formParams,
                    description: e.target.value,
                  })
                }
                value={formParams.description}
              ></textarea>
            </div>
            <div className={styles.inputRow}>
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, beds: e.target.value })
                }
                value={formParams.beds}
                type="text"
                placeholder="Beds"
              />
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, bath: e.target.value })
                }
                value={formParams.bath}
                type="text"
                placeholder="Bath"
              />
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, sqft: e.target.value })
                }
                value={formParams.sqft}
                type="text"
                placeholder="Sqft"
              />
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, lotSqft: e.target.value })
                }
                value={formParams.lotSqft}
                type="text"
                placeholder="lotSqft"
              />
              <input
                onChange={(e) =>
                  updateFormParams({ ...formParams, yearBuilt: e.target.value })
                }
                value={formParams.yearBuilt}
                type="text"
                placeholder="YearBuilt"
              />
            </div>
            <div className={styles.dropDown}>
              <h6
                onClick={() => {
                  setOpenDrop((prev) => {
                    return !prev;
                  });
                }}
              >
                Type: {dropdownContent} <FontAwesomeIcon icon={faChevronDown} />
              </h6>
              <div
                className={`${styles.mainDrop} ${
                  openDrop && styles.activeDrop
                }`}
              >
                <ul>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Single Family
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Condo
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Townhome
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Multi-Family
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Land
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Mobile/Manufactured
                  </li>
                  <li
                    onClick={(e) => {
                      setDropdownContent(e.target.innerText);
                      setOpenDrop(false);
                    }}
                  >
                    Other
                  </li>
                </ul>
              </div>
            </div>

            <button onClick={listNFT} type="submit" className="cta-btn">
              Create
            </button>
          </form>
        </div>
        <div className={styles.rightBottom}>
          <h1>Preview item</h1>
          <Card
            imageUrl={uploadedImage || cardBg}
            bath={formParams.bath}
            beds={formParams.beds}
            sqft={formParams.sqft}
            yearBuilt={formParams.yearBuilt}
            name={formParams.name}
            address={nftAddress}
            pointerNone={true}
          />
        </div>
      </div>
    </div>
  );
}

export default Create;
